import styled from 'styled-components';

export const Container = styled.div`
    display: flex;
`;
Container.displayName = 'Container';

export const Text = styled.p`
    color: ${ ({ theme: { labelColor, textColor }, accent }) => accent ? labelColor : textColor };
    font-size: ${ ({ fontSize }) => fontSize || '.85rem' };
    font-weight: 500;
    margin-bottom: 5px;
    margin-right: 5px;
    text-align: center;
`;
Text.displayName = 'Text';
